<template>
  <div class="courses-mobile">
    <div class="search-area">
      <div
        class="search-button"
        @click="visibleChange"
      >
        {{ curName ? curName : "学科分类"
        }}<i
          class="iconfont iconsanjiaoxing-down"
          :class="{'shouqi': showSelect}"
        ></i>
      </div>
      <div
        class="search-button"
        @click="goSearch"
      >
        <span class="iconfont iconsousuo"></span>
        <span>搜索</span>
      </div>
    </div>
    <div class="drawer-wrapper">
      <el-drawer
        direction="ttb"
        :visible.sync="showSelect"
        :with-header="false"
        :modal-append-to-body="false"
        :custom-class="'my-drawer'"
        :size="'302px'"
      >
        <el-scrollbar class="subject-list-wrapper">
          <div class="subject-list">
            <div
              class="item"
              v-for="item in subjectList"
              :key="item.classifyId"
              :class="{'active': params.parentId === item.classifyId}"
              @click="changeClassify(item)"
              @touchend="changeClassify(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-scrollbar>
      </el-drawer>
    </div>
    <div
      class="course-area container"
      ref="scrollLoad"
    >
      <div class="total">
        搜索到<span class="num">{{ total }}</span>门相关课程
      </div>
      <MobileList
        :courseList="mobileCourseList"
        :maxCount="maxCount"
      />
      <div class="loading" v-if="pageNum > 1 && loading">加载中...</div>
    </div>
  </div>
</template>
<script>
import MobileList from "./mobileList.vue";
import { getMore } from "@/libs/tools.js";
export default {
  name: "courses_pc",
  components: {
    MobileList,
  },
  props: {
    subjectList: {
      type: Array,
      default() {
        return [];
      },
    },
    mobileCourseList: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNum: 1,
      keyVaule: "",
      classifyId: "",
      showSelect: false,
      curName: ""
    };
  },
  computed: {
    maxCount() {
      return (
        parseInt(this.total / this.params.ps) +
        (this.total % this.params.ps > 0 ? 1 : 0)
      );
    },
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.pageNum = this.params.pn;
      this.keyVaule = this.params.key;
      this.classifyId = this.params.parentId;
    },
    visibleChange() {
      this.showSelect = !this.showSelect;
    },
    changeKey() {
      this.$emit("changeKey", this.keyVaule);
    },
    changeClassify(item) {
      this.curName = item.name;
      this.showSelect = false;
      this.$emit("changeClassify", item.classifyId);
    },
    changePageNum() {
      this.$emit("changePageNum", this.pageNum);
    },
    goSearch() {
      this.$router.push({
        path: `/whkcsz/searchCourse/${this.classifyId}/${this.params.classifyId}`
      });
    },
  },
  watch: {
    params: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    loading() {
      if (!this.loading) {
        this.$nextTick(() => {
          const ele = document.body;
          getMore(
            ele,
            () => {
              if (this.pageNum < this.maxCount) {
                this.pageNum++;
                this.$emit("changePageNum", this.pageNum);
              }
            },
            500
          );
        });
      }
    }
  },
  destroyed() {
    document.body.onscroll = null
  }
};
</script>
<style lang="scss" scoped>
@import "../../variables.scss";
.courses-mobile {
  .search-area {
    position: fixed;
    left: 0;
    top: 50px;
    z-index: 3;
    width: 100%;
    height: 50px;
    padding: 13px 15px;
    background-color: #f8f8f8;
    .search-button {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      line-height: 24px;
      &:first-child {
        position: relative;
        width: 74%;
        border-right: 1px solid #eeeeee;
        .iconfont {
          position: absolute;
          top: 0;
          right: 15px;
          font-size: 12px;
          &.shouqi {
            color: $primary-color;
            transform: rotate(180deg);
          }
        }
      }
      &:last-child {
        width: 26%;
        padding-left: 20px;
        font-size: 0;
        span {
          display: inline;
          vertical-align: middle;
          font-size: 14px;
        }
        .iconfont {
          margin-right: 6px;
          font-size: 18px;
          color: #969696;
        }
      }
    }
  }
  .drawer-wrapper {
    position: relative;
    z-index: 2;
    /deep/.my-drawer {
      top: 100px;
      width: 100%;
      .subject-list-wrapper {
        height: 302px;
        .subject-list {
          padding: 8px 0;
          .item {
            padding: 12px 15px;
            font-size: 15px;
            line-height: 22px;
            &.active {
              color: $primary-color;
            }
            &:hover {
              background-color: #f5f5f5;
            }
          }
        }
      }
    }
  }
  .course-area {
    padding-top: 50px;
    .total {
      margin: 16px 0;
      font-size: 14px;
      color: #888888;
      line-height: 20px;
      .num {
        margin: 0 2px;
        color: #444444;
      }
    }
  }
  .loading {
    margin: -5px 0 20px;
    text-align: center;
    font-size: 14px;
    color: #969696;
  }
}
</style>